import React from "react";
import Layout from "../../layout/Layout";
import Head from "../Head";

const AboutUs = () => {
  return (
    <div>
      <Layout>
        <div className="min-height-screen container mx-auto px-2 my-6">
          <Head title="About Us" />
          <div className="xl:py-20 py-10 px-4">
            <div className="grid grid-flow-row xl:grid-cols-2 gap-4 xl:gap:16 items-center">
              <div>
                <h3 className="text-xl lg:text-3xl mb-4 font-semibold ">
                  Welcome to Our Movie World
                </h3>

                <div className="mt-3 text-sm leading-8 text-text">
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Ducimus inventore, et accusantium fugit neque dolore
                    voluptate est exercitationem! Eveniet sunt fugiat similique.
                    Quas nesciunt non enim repudiandae voluptatibus itaque
                    ratione? Lorem ipsum dolor, sit amet consectetur adipisicing
                    elit. Quod eaque praesentium repellat nam distinctio cum
                    exercitationem libero quae, animi fugit neque doloribus
                    nihil qui harum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Vero ex iusto incidunt dolor provident aliquid rem et ipsam,
                    facilis qui!
                  </p>
                </div>
                <div className="grid md:grid-cols-2 gap-6 mt-8">
                  <div className="p-8 bg-dry rounded-lg">
                    <span className="text-3xl block font-extrabold">10k</span>
                    <h4 className="text-lg font-semibold my-2">
                      Listed Movies
                    </h4>
                    <p className="mb-0 text-text leading-7 texxt-sm">
                      Lorem ipsum dolor sit amet consectetur adipisicing
                    </p>
                  </div>

                  <div className="p-8 bg-dry rounded-lg">
                    <span className="text-3xl block font-extrabold">8k</span>
                    <h4 className="text-lg font-semibold my-2">Lovely Users</h4>
                    <p className="mb-0 text-text leading-7 texxt-sm">
                      Lorem ipsum dolor sit amet consectetur adipisicing
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-10 lg:mt-0">
                <img
                  src="../images/aboutus.jpg"
                  alt="aboutus"
                  className="w-full xl:block hidden h-header rounded-lg object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default AboutUs;
